import { render } from "./PageListComponent.vue?vue&type=template&id=27d680be"
import script from "./PageListComponent.vue?vue&type=script&lang=js"
export * from "./PageListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Page/PageListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27d680be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27d680be', __exports__)) {
    api.reload('27d680be', __exports__)
  }
  
  module.hot.accept("./PageListComponent.vue?vue&type=template&id=27d680be", () => {
    api.rerender('27d680be', render)
  })

}


export default __exports__